<template>
  <div class="page">
    <div class="enterprise-title">
      <div class="back-icon" @click="goBack">
        <span class="back-arrow"></span>
      </div>
      <div class="enterprise-text">征信</div>
    </div>
    <div class="detailView">
      <div class="detailtitle">
        <div class="leticon"></div>
        <div class="titletxt">上传个人征信</div>
      </div>
      <div class="pdfview">
        <div class="pdfitem" @click="showgrPdfFile">
          <img src="@/assets/img/pdf.png" width="100%" />
          <div class="clicktxt">点击查看</div>
        </div>
      </div>
    </div>

    <div class="detailView">
      <div class="detailtitle">
        <div class="leticon"></div>
        <div class="titletxt">上传企业征信</div>
      </div>
      <div class="pdfview">
        <div class="pdfitem" @click="showqyPdfFile">
          <img src="@/assets/img/pdf.png" width="100%" />
          <div class="clicktxt">点击查看</div>
        </div>
      </div>
    </div>

    <!-- 按钮行 -->
    <div class="button-row">
      <div 
        class="home-button" 
        @click="goToHome"
      >
        <van-icon name="wap-home" size="16" />
      </div>
    </div>
  </div>
</template>

<script>
import request from "@/utils/request";

export default {
  data() {
    return {
      qiyeWord: "",
      gerenWord: "",
    }
  },
  props: {
    id: {
      type: String,
      value: "",
    }
  },
  created(){
    this.getDetail();
  },
  methods: {
    getDetail() {
      let self = this;
      request.get("/Data/ReportTask/GetReportRecord", { params: { id: this.id } }).then((res) => {
        self.qiyeWord = res.data.data.firmPTPUrl;
        self.gerenWord = res.data.data.personagePTPUrl;
      })
    },
    showgrPdfFile() {
      window.open(this.gerenWord)
    },
    showqyPdfFile() {
      window.open(this.qiyeWord)
    },
    // 返回上一页
    goBack() {
      this.$router.back();
    },
    // 返回首页
    goToHome() {
      this.$router.push("/credit/home");
    },
  }
}
</script>

<style lang="less" scoped>
.page {
  background: #F0F4FF;
  height: 100vh;
}

.enterprise-title {
  display: flex;
  align-items: center;
  background-color: #ffffff;
  padding: 12px;
  width: 100%;
  position: relative;
  min-height: 44px;
}

.back-icon {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  z-index: 10;
  flex-shrink: 0;
}

.back-arrow {
  display: inline-block !important;
  width: 10px;
  height: 10px;
  border-left: 2px solid #333;
  border-bottom: 2px solid #333;
  transform: rotate(45deg);
  margin-right: 4px;
  visibility: visible !important;
  opacity: 1 !important;
}

.enterprise-text {
  position: absolute;
  left: 47.5%;
  transform: translateX(-50%);
  font-size: 18px;
  font-weight: 500;
}

.detailView {
  margin-top: 1rem;
  background: #ffffff;
}

.pdfview {
  padding: .5rem 1rem;
}

.pdfitem {
  width: 10rem;
  height: 6rem;
  background: rgb(167, 167, 167);
  position: relative;
  margin-left: .5rem;
  display: inline-block;
  overflow: hidden;
}

.clicktxt {
  position: absolute;
  bottom: 0;
  background: rgba(0, 0, 0, .5);
  color: #ffffff;
  width: 100%;
  text-align: center;
  font-size: .7rem;
  line-height: 1rem;
}

.topmessage {
  position: relative;
  height: 2.5rem;
  border-top: solid 1px #efefef;
  background: #ffffff;
}

.toptips {
  line-height: 2.5rem;
  font-size: .8rem;
  color: #333;
  padding-left: .8rem;
}

.button-row {
  position: fixed;
  bottom: 20px;
  left: 16px;
  right: 16px;
  padding: 10px 0;
  display: flex;
  align-items: center;
  gap: 12px;
  z-index: 999;
  justify-content: flex-end;
}

.home-button {
  width: 44px;
  height: 44px;
  background-color: #176FCA;
  border-radius: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  cursor: pointer;
  transition: background-color 0.3s;
  flex-shrink: 0;
}

.home-button:hover {
  background-color: #145EAB;
}
</style>